import React from "react";
import { Row, Col } from "react-bootstrap";
import "./NewProducts.css";

// Import hero images
import bellMathsHero from "../../images/Hero1/BellMaths-1.png";
import bellDiaryHero from "../../images/Hero1/BellDairy-1.png";
import encycGamesHero from "../../images/Hero1/Encycgames-1.png";

const NewProducts = () => {
  const products = [
    {
      id: "bellmaths",
      name: "BellMaths",
      category: "EdTech",
      aiLabel: "AI",
      description: "Advanced AI-powered mathematics learning platform for students and educators",
      fullDescription: "BellMaths is an innovative AI-powered mathematics learning platform designed to transform how students learn and practice mathematics. With intelligent problem generation and personalized learning paths, BellMaths makes math education engaging and effective.",
      image: bellMathsHero,
      logo: "/belldairy/BellDairyLogo.png",
      domain: "https://www.bellmaths.com",
      features: [
        "AI-powered problem generation",
        "Personalized learning paths",
        "Real-time feedback and assessment",
        "Interactive math practice",
        "Progress tracking and analytics"
      ]
    },
    {
      id: "encycgames",
      name: "EncycGames",
      category: "Sports Tech",
      aiLabel: "AI",
      description: "EncycGames is a unified multi-sport learning, assessment and performance platform for players of all ages and levels.",
      fullDescription: "Build foundations, measure performance, prove skills and progress through clear pathways—at home, in schools or at academies.",
      image: encycGamesHero,
      logo: "/belldairy/BellDairyLogo.png",
      domain: "https://www.encycgames.com",
      features: [
        { title: "Structured Multi-Sport Learning", text: "Age- and level-appropriate skills, drills, fitness, safety and sports knowledge across 50+ sports." },
        { title: "Performance Assessment and Scorecards", text: "Measure technique, accuracy, consistency, speed and control through structured assessments and actionable scorecards." },
        { title: "Prove Skills Beyond Tournaments", text: "Participate in inclusive skill challenges, earn certificates and demonstrate ability without depending only on tournament selection." },
        { title: "Rankings and Development Pathways", text: "Track progress, identify strengths and gaps, reassess performance and move toward tournaments, academies and elite opportunities." },
        // Hidden for now
        // { title: "Connected Sports Ecosystem", text: "Bring players, parents, coaches, schools, academies, creators and partners together through a unified Sports Passport and performance record." }
      ]
    },
    {
      id: "belldiary",
      name: "BellDiary",
      category: "EdTech",
      aiLabel: "AI",
      description: "Transforming syllabi into textbooks, schedules, and labs through agentic AI. Collaborate in real-time from curriculum to mastery.",
      fullDescription: "Bell Diary is an AI-driven ecosystem that automates the heavy lifting of educational planning and content creation. By leveraging agentic AI, the platform deconstructs any syllabus into a structured digital book, complete with day-by-day teaching schedules, hands-on lab exercises, and automated assessments. It fosters a collaborative environment where teachers and students interact through NotebookLM-style insights and integrated chat, turning static curricula into dynamic, personalized learning paths.",
      image: bellDiaryHero,
      logo: "/belldairy/BellDairyLogo.png",
      domain: "https://www.belldiary.com",
      features: [
        "Agentic Content Synthesis: Automatically generates detailed textbooks, practical lab manuals, and assessments directly from your syllabus.",
        "Dynamic Scheduling: Crafts a granular daily teaching and practice calendar that adapts to the specific needs of your academic term.",
        "Collaborative AI Hub: Enables students and teachers to interact with course materials through shared notebooks and intelligent chat interfaces.",
        "Integrated Practical Labs: Delivers step-by-step lab instructions and experimental frameworks to bridge the gap between theory and practice.",
        "Holistic Assessment Engine: Simplifies evaluation with AI-generated quizzes and assignments designed to track progress in real-time."
      ]
    }
  ];

  return (
    <div className="new-products-container">
      <div className="products-content-wrapper">
        {products.map((product, index) => (
          <div key={product.id} className={`product-section ${index % 2 === 0 ? "even" : "odd"}`}>
            <Row className={`product-row ${index % 2 === 1 ? "reverse" : ""}`}>
              <Col md={6} className="product-image-col">
                <div className="product-image-wrapper">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="product-hero-image"
                  />
                </div>
              </Col>

              <Col md={6} className="product-content-col">
                <div className="product-content">
                  <div className="product-badges">
                    <span className="product-category-badge">{product.category}</span>
                    <span className="product-ai-badge">{product.aiLabel}</span>
                  </div>
                  <h2 className="product-name">{product.name}</h2>
                  <p className="product-short-description">{product.description}</p>
                  <p className="product-full-description">{product.fullDescription}</p>

                  <div className="product-features">
                    <h4 className="product-features-title">Key Features:</h4>
                    <ul className="product-features-list">
                      {product.features.map((feature, idx) => (
                        <li key={idx}>
                          {typeof feature === "string" ? (
                            feature
                          ) : (
                            <>
                              <strong>{feature.title}</strong>
                              {feature.text}
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {product.id !== "encycgames" && (
                  <div className="product-launch-btn">
                    <a
                      href={product.domain}
                      target="_blank"
                      rel="noreferrer"
                      className="launch-link"
                    >
                      Explore {product.name} →
                    </a>
                  </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewProducts;
